import type { EntityId } from '../types';

export const LOCAL_PLAYER_ENTITY_ID: EntityId = 1;
export const DEFAULT_OPPONENT_ENTITY_ID: EntityId = 2;
